import { render, staticRenderFns } from "./GatewayListHeader.vue?vue&type=template&id=0c58b4e6&scoped=true&lang=pug"
import script from "./GatewayListHeader.vue?vue&type=script&lang=ts"
export * from "./GatewayListHeader.vue?vue&type=script&lang=ts"
import style0 from "./GatewayListHeader.vue?vue&type=style&index=0&id=0c58b4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58b4e6",
  null
  
)

export default component.exports